<template>
  <default-layout v-if="error?.statusCode === 404" is-aw-spring>
    <aw-not-found-error-page
      v-if="$awMergedConfig.isShop"
    />
    <aw-simple-error-page-with-image
      v-else
      :error-code="error.statusCode"
    />
  </default-layout>
  <default-layout v-else-if="error?.statusCode === 422 && error.statusMessage === CAREER_PAGES_TURNED_OFF" is-aw-spring>
    <aw-career-turned-off-error-page
      v-if="$awMergedConfig.isShop"
    />
    <aw-simple-error-page-with-image
      v-else
      :error-code="error.statusCode"
    />
  </default-layout>
  <aw-simple-error-page-with-image
    v-else
    :error-code="error.statusCode"
    :class="$style.layoutlessError"
  />
</template>
<script setup>
  import { useNuxtApp } from 'nuxt/app';
  import { useBreadcrumbStore } from '~~/common/stores/breadcrumb';
  import DefaultLayout from '~/layouts/default';
  import AwSimpleErrorPageWithImage from '~~/common/components/AwSimpleErrorPageWithImage.vue';
  import AwNotFoundErrorPage from '~~/common/components/AwNotFoundErrorPage.vue';
  import AwCareerTurnedOffErrorPage from '~~/common/components/AwCareerTurnedOffErrorPage.vue';
  import { CAREER_PAGES_TURNED_OFF } from '~~/common/config/CareerTurnedOffConfig';

  const props = defineProps({
    error: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  });

  const { $logger } = useNuxtApp();

  if (props.error.statusCode !== 404 && !(props.error.statusCode === 422 && props.error.statusMessage === CAREER_PAGES_TURNED_OFF)) {
    $logger.error(props.error);
  }

  useBreadcrumbStore().setBreadcrumbs([]);
</script>

<style module lang="scss" rel="stylesheet/scss">
.layoutlessError {
  min-height: 100vh;
  margin: 0 8px;
}
</style>
